import { useEffect, useState } from "react";
import axios from "axios";

const useAxios = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [controller, setController] = useState();

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  const fetchData = async (configObj) => {
    const { url, method, data = {}, params = {} } = configObj;

    const token = localStorage.getItem("api_token");

    try {
      setLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      // When sending FormData (file uploads), omit Content-Type so axios
      // can auto-set "multipart/form-data; boundary=..." with the correct boundary.
      // For everything else, default to JSON.
      const headers = {
        Authorization: `Bearer ${token}`,
        ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
      };

      const result = await axiosInstance({
        url,
        method,
        headers,
        data,
        params,
        signal: ctrl.signal,
      });
      setResponse(result.data);
      return result.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.error("Request cancelled", error.message);
      } else {
        setError(error.response ? error.response.data : error.message);
        throw error;
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => controller && controller.abort();
  }, [controller]);

  return { response, error, loading, fetchData };
};

export default useAxios;
